<!--
 * @Author: 张志明
 * @Date: 2022-08-26 16:33:36
 * @LastEditTime: 2022-08-26 17:58:39
 * @Description:
-->
<template>
    <el-popover placement="bottom" width="180" trigger="hover" content="">
        <span slot="reference" class="mr2">
            <img src="../../../../../assets/img/recommend.png" class="recommend" :style="cssStyle" alt=""
        /></span>
        <div>“推荐属性”填写越完整，商品在1688站内曝光将越高</div>
    </el-popover>
</template>

<script>
export default {
    components: {},
    props: {
        cssStyle: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.recommend {
    position: relative;
    top: -2px;
}
</style>
